import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { Spin, Typography } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import UnsavedChangesWarning from "components/UnsavedChangesWarning";
import logo from "assets/images/logo-black.svg";
import LangPicker from "components/lang-picker";
import { CONSTANTS as C } from "config";
import AuthImage from "./auth.svg";

const FooterLinks = [
  {
    label: "Privacy Policy",
    href: "https://www.resthero.io/privacy",
  },
  {
    label: "Terms and Conditions",
    href: "https://www.resthero.io/terms",
  },
  {
    label: "About Us",
    href: "https://www.resthero.io/",
  },
  {
    label: "Contact Us",
    href: "https://www.resthero.io/",
  },
];

const AuthLayout = ({
  leftExtraContent,
  title,
  description,
  children,
  loading = false,
  isModified = false,
  showBackButton = true,
  onBackButtonClick,
}) => {
  const { t, i18n } = useTranslation();
  const router = useHistory();
  return (
    <>
    <UnsavedChangesWarning hasUnsavedChanges={loading ? false:isModified} />
    <Spin spinning={loading}>
      <main className="bg-surface h-screen">
        <div className="mx-auto container h-full w-full p-5 md:py-10 flex flex-col justify-between gap-4">
          <header className="flex justify-between items-center gap-4 flex-wrap">
            <Link to="/">
              <img
                src={logo}
                alt="logo"
                style={{
                  transform: i18n.language === "ar" ? "scaleX(-1)" : "none",
                }}
              />
            </Link>

            <LangPicker />
          </header>
          <br />
          <div className="flex-1 grid grid-cols-1 lg:grid-cols-5 gap-4 items-start justify-center w-full">
            {/* left section */}
            <section
              className={`order-2 lg:order-1 lg:col-span-2 flex flex-col gap-8 ${leftExtraContent
                ? "items-center justify-start"
                : "items-center justify-center"
                } h-full w-full`}
            >
              {leftExtraContent}
              <img
                src={AuthImage}
                alt="auth Image"
                style={{
                  transform: i18n.language === "ar" ? "scaleX(-1)" : "none",
                }}
              />
            </section>
            {/* right section */}
            <section className="order-1 lg:order-2 lg:col-span-3 border border-theme-blue-light-2 bg-white rounded-2xl p-12 w-full h-full shadow-sm flex flex-col gap-4">
              <div className="flex gap-4 items-start">
                {showBackButton && <button className="cursor-pointer hover:text-blue-500 transition-all duration-300" onClick={() => {
                  if (onBackButtonClick) {
                    onBackButtonClick();
                  } else {
                    router.goBack();
                  }
                }}>
                  {
                    i18n.language === "ar" ? (
                      <ArrowRightOutlined style={{ fontSize: '28px' }} />
                    ) : (
                      <ArrowLeftOutlined style={{ fontSize: '28px' }} />
                    )
                  }
                </button>}
                {(title || description) && (
                  <div className="flex flex-col gap-2">
                    {title && (
                      <Typography.Title
                        level={3}
                        className="capitalize"
                        style={{ marginBottom: 0, fontWeight: 700 }}
                      >
                        {title}
                      </Typography.Title>
                    )}
                    {description && (
                      <Typography.Text
                        style={{
                          marginTop: 0,
                          color: "#858D98",
                          fontWeight: 500,
                        }}
                      >
                        {description}
                      </Typography.Text>
                    )}
                  </div>
                )}
              </div>
              {children}
            </section>
          </div>
          <br />
          <footer className="flex justify-between gap-4 flex-wrap text-slate-400 capitalize mb-5">
            <span className="">
              {" "}
              ©{" "}
              {t("COPYRIGHT", {
                year: "2023",
                company: process.env.REACT_APP_COMPANY_NAME,
              })?.toLowerCase()}
            </span>

            {process.env.REACT_APP_COMPANY_NAME ===
              C.COMPANY_NAMES.RESTHERO && (
                <div className="flex items-center gap-4">
                  {FooterLinks.map((link) => (
                    <a
                      key={link.label + "-" + link.href}
                      href={link?.href}
                      className="text-slate-400 transition-all duration-200 hover:text-blue-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(link?.label)}
                    </a>
                  ))}
                </div>
              )}
          </footer>
        </div>
      </main>
    </Spin>
    </>
  );
};

export default AuthLayout;
